// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"318b7914","408":"9b1018ea","427":"4d67ad73","736":"bc93d822","899":"1c142249"}[chunkId] + ".chunk.js";
};